import { PawPrint } from 'lucide-react';
import { Link } from 'react-router-dom';

export interface PetSummary {
  id: string;
  name: string;
  species: string;
  breed: string | null;
  sizeCategory: string | null;
  color: string | null;
  microchip: string | null;
  photoUrl: string | null;
}

interface PetCardProps {
  pet: PetSummary;
}

export function PetCard({ pet }: PetCardProps) {
  return (
    <Link
      to={`/account/pets/${pet.id}`}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.6rem',
        textDecoration: 'none',
        color: 'inherit',
      }}
    >
      {/* Photo block */}
      <div
        style={{
          width: '100%',
          aspectRatio: '1 / 1',
          borderRadius: '12px',
          overflow: 'hidden',
          background: 'oklch(0.94 0.005 80)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {pet.photoUrl ? (
          <img
            src={pet.photoUrl}
            alt={pet.name}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        ) : (
          <PawPrint size={32} style={{ color: 'var(--muted-foreground, oklch(0.52 0.008 75))' }} />
        )}
      </div>

      {/* Name */}
      <div>
        <div style={{ fontSize: '0.9rem', fontWeight: 500 }}>{pet.name}</div>
        <div
          style={{
            fontSize: '0.78rem',
            color: 'var(--muted-foreground, oklch(0.52 0.008 75))',
          }}
        >
          {pet.species}
          {pet.breed ? ` · ${pet.breed}` : ''}
        </div>
      </div>
    </Link>
  );
}
